import { render } from "./emailconfigadd.vue?vue&type=template&id=47181902&scoped=true"
import script from "./emailconfigadd.vue?vue&type=script&lang=js"
export * from "./emailconfigadd.vue?vue&type=script&lang=js"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47181902"]])

export default __exports__